/** @domain auth -- Authentication and security credentials: passwords, OTP, security questions, recovery codes. */
import { z } from 'zod';
import { createDomainField } from './types';
import { stripNonDigits } from './formatters';

const define = createDomainField('auth');

export const password = define({
  label: 'Password',
  placeholder: 'Enter password',
  schema: z.string().min(1, 'Required'),
  adapterHint: 'text',
  displayFormat: 'masked',
});

export const newPassword = define({
  label: 'New Password',
  placeholder: 'Enter new password',
  schema: z
    .string()
    .min(8, 'Must be at least 8 characters')
    .regex(
      /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}/,
      'Must contain uppercase, lowercase, number, and special character',
    ),
  adapterHint: 'text',
  displayFormat: 'masked',
});

export const repeatPassword = define({
  label: 'Confirm Password',
  placeholder: 'Re-enter password',
  schema: z.string().min(1, 'Required'),
  adapterHint: 'text',
  displayFormat: 'masked',
});

export const currentPassword = define({
  label: 'Current Password',
  placeholder: 'Enter current password',
  schema: z.string().min(1, 'Required'),
  adapterHint: 'text',
  displayFormat: 'masked',
});

export const otp = define({
  label: 'Verification Code',
  placeholder: 'Enter code',
  schema: z.string().min(1, 'Required'),
  adapterHint: 'otp',
  formatter: stripNonDigits,
  displayFormat: 'text',
});

export const securityQuestion = define({
  label: 'Security Question',
  schema: z.string(),
  adapterHint: 'select',
  displayFormat: 'text',
});

export const securityAnswer = define({
  label: 'Security Answer',
  placeholder: 'Enter your answer',
  schema: z.string().max(200, 'Must be at most 200 characters'),
  adapterHint: 'text',
  displayFormat: 'text',
});

export const signature = define({
  label: 'Signature',
  placeholder: 'Type your full name as signature',
  schema: z.string(),
  adapterHint: 'text',
  displayFormat: 'text',
});

export const recoveryCode = define({
  label: 'Recovery Code',
  placeholder: 'Enter recovery code',
  schema: z.string().min(1, 'Required'),
  adapterHint: 'text',
  displayFormat: 'text',
});
